export const PALETTE_SIZE = 12;

/**
 * Deterministically maps an arbitrary seed string to an avatar color index (1–N).
 * Uses FNV-1a 32-bit for fast, well-distributed hashing with no collisions for
 * short strings (UUIDs, names).
 */
export function getAvatarColorIndex(seed: string, paletteSize: number = PALETTE_SIZE): number {
  let hash = 2166136261; // FNV-1a offset basis (32-bit unsigned)
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i);
    hash = Math.imul(hash, 16777619) >>> 0; // FNV prime, keep 32-bit unsigned
  }
  return (hash % paletteSize) + 1;
}
